import { render } from "./ask.vue?vue&type=template&id=d2c3ff8e&scoped=true"
import script from "./ask.vue?vue&type=script&lang=js"
export * from "./ask.vue?vue&type=script&lang=js"

import "./ask.vue?vue&type=style&index=0&id=d2c3ff8e&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2c3ff8e"]])

export default __exports__